<template>
  <div>
    <page-heading-info
    title="Jefferson County Treasurer's Office"
    phone="(740) 283-8572"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="1st Floor, Room 105"
    ></page-heading-info>

    <div class="row">
      <div class="col-md-6 mt-3 order-1 order-md-0">
        <p>
        The County Treasurer collects taxes and is the Investment Officer for the County. The Treasurer is also a member of the County Budget Commission, the County Board of Revision and the Data Processing Board.
        </p>

        <p>
        If you have a question and cannot find the answer here, or on the <router-link to="/auditor" class="text-light-blue-10 text-bold link-hover">Auditor's page</router-link>, get in touch with us by telephone at <span class="text-bold one-line">(740) 283-8572</span> or in person on the First Floor of the Jefferson County Court House. Our office staff is available to assist you in any way possible.
        </p>

				<hr class="title-rule mt-4" style="border-width: 3px;"/>

				<div class="mt-4">
					<note-text note-id="35"></note-text>
				</div>

      </div>

			<div class="col-md-6 mt-3 image-flex order-0 order-md-1">
        <img src="static/images/general/courthouse_front_02.jpg" alt="View of the courthouse from the corner of 3rd and Market Street." class="border-1 text-dark" />
      </div>

    </div>

     <!-- Paying Taxes Options -->
      <text-box-title
      title="Tax Bill"
      title2="Payment Options"
      default="false"
      align="left">

      <div class="col-md-6 p-3">
        <icon-title
        title="Pay By Phone"
        icon="phone"
        underline="true"
        ></icon-title>

        <p>
          You may make payments for Real Estate Property and/or Manufactured Homes with your credit card by phone or over the internet.
        </p>
        <p>
          To make a payment by telephone call (877) 690-3729 using jurisdiction code 4577
        </p>
        <p>
          If you have a problem or need assistance, <br />please call (866) 290-5400 ext. 1.
        </p>
        <p>
          Forte Payment Systems charges a nominal fee for this service.
        </p>

      </div>

      <div class="col-md-6 p-3">
        <icon-title
        title="Pay Online"
        icon="computer"
        underline="true"
        ></icon-title>

        <p>
          To make a payment on-line, click below and you will be re-directed to the Forte Payment Systems website.
        </p>
        <p>
          Payment processing is handled by Forte Payment Systems. They accept Visa, Master Card, American Express, and Discover Card.
        </p>
        <p>
          Forte Payment Systems charges a nominal fee for this service.
        </p>

        <div>
          <link-box
          bg-color="dark"
          dark="true"
          icon="payment"
          icon-color="light"
          title-color="light"
          title="Make a Payment"
          title-align="left"
          url="https://billpay.forte.net/JEFFERSONCOOHTAX/">
            Click here to make a payment
          </link-box>
        </div>

      </div>

      <div class="col-md-6 p-3">
        <icon-title
        title="Pay By Mail"
        icon="email"
        underline="true"
        ></icon-title>
        <p>
          <strong>You may mail a check, money order or cashier check to:</strong>
        </p>

        <p>
          Jefferson County Treasurer<br />
          P.O. Box 398<br />
          Steubenville, OH 43952<br /><br />
          <i>We honor the postmark date</i>
        </p>

      </div>

      <div class="col-md-6 p-3">
        <icon-title
        title="Drop Off Box"
        icon="move_to_inbox"
        underline="true"
        ></icon-title>

        <p>
          You can place a check, money order or cashier check in our drop off box which is located on the alley side of the Court House.
        </p>

      </div>

      </text-box-title>

      <!-- tax rates document list -->
      <text-box-title class="mt-3" title="Jefferson County Tax Rates">
        <note-documents note-id="27" class="ml-3 mr-3 mt-3"></note-documents>
      </text-box-title>

      <!-- Tax Installment Payment Plan -->
      <text-box-title
      title="Tax Installment"
      title2="Payment Plan"
      title3="(T.I.P)"
      default="false"
      align="left"
      class="mt-3">

        <div class="col-md-6 p-3 tax-desc">
          <icon-title
          title="Information"
          icon="info"
          underline="true"
          ></icon-title>

          <div>
            The Jefferson County Treasurer's office has created a Tax Installment Payment Plan. 
            Jefferson County residents have an option of making monthly payments instead of semi-annual real estate tax payments.
          </div>
        </div>

        <div class="col-md-6 p-3 tax-desc">
          <icon-title
          title="Here's How It Works"
          icon="how_to_reg"
          underline="true"
          ></icon-title>

          <div class="ml-3">
          <ul>
            <li>
              You must be current on your taxes to enroll.
            </li>
            <li>
              Read and Sign the Agreement
            </li>
            <li>
              Your Semi-Annual taxes are divided into monthly payments
            </li>
            <li>
              You will recieve payment coupons from the Treasurers Office
            </li>
            <li>
              There is NO fee for participating in the T.I.P Program
            </li>
          </ul>
          </div>

        </div>

      </text-box-title>

      <!-- Tax Installment Payment Plan FAQ's -->
      <text-box-title
      title="Tax Installment"
      title2="Payment Plan"
      title3="FAQ's"
      default="false"
      align="left"
      class="mt-3">

        <div class="col-md-4 mt-3">
          <div>
            
            <icon-title
            title="How much will I have to pay?"
            icon="help"
            underline="true"
            ></icon-title>

            <div class="margin-bottom-05"></div>
              <p>
                Your Payments will be based on your most recent tax bill.The sum of prepayments must be equal too or exceed the full 
                amount of taxes due for that period to avoid making additional payments.
              </p>
              <p>
                If there is an outstanding balance after the final monthly payment is made, you will receive a bill.
                Any unpaid balance on current taxes will be charged a late penalty and interest in accordance with the Ohio Revised Code.
              </p>
          </div>
        </div>

        <div class="col-md-4 mt-3">
          <div>
            <icon-title
            title="Who benefits from T.I.P?"
            icon="help"
            underline="true"
            ></icon-title>

            <div class="margin-left-1 li-pad-top-1">
              <ul>
                <li>
                  Senior Citizens, many of whom are on fixed incomes and who find it difficult to pay large bills twice a year.
                </li>
                <li>
                  Many homeowners who want to simplify their household budgeting by making payments in equal, monthly amounts.
                </li>
                <li>
                  Local school districts, because regular, timely real estate tax collections fund the education of our children.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-4 p-3">
          <div>
            <icon-title
            title="Can more than one payment be made in advance?"
            icon="help"
            underline="true"
            ></icon-title>

            You may make double payments in any month before the current tax collection closes.
          </div>
        </div>

      </text-box-title>

      <text-box-title
      title="Points To Remember"
      default="false"
      align="left">

        <div class="col-md-4 p-3">
          <icon-text icon="check_box">
            The T.I.P program is available as a service to Jefferson County residents. It is not required by Ohio Law.
          </icon-text>
        </div>

        <div class="col-md-4 p-3">
          <icon-text icon="check_box">
            The Jefferson County Treasurer's Office DOES NOT charge a fee for participation in T.I.P.
          </icon-text>
        </div>

        <div class="col-md-4 p-3">
          <icon-text icon="check_box">
            Your real estate taxes may change from year to year based upon new levies and/or re-evaluations. Those changes may affect your T.I.P payments.
          </icon-text>
        </div>

      </text-box-title>

      <div class="row justify-content-center bg-dark text-light mt-4 ml-3 mr-3">
        <div class="col-md-8 p-3 text-center">
          If you have questions or would like more information regarding the Tax Installment Payment Plan, please call the Jefferson County Treasurer's Office at <span class="text-jeff-yellow">(740) 283-8572</span>
        </div>
      </div>

      <!-- Paying Taxes FAQ's -->
      <treasurer-faq></treasurer-faq>


  </div>
</template>

<script>
import TreasurerFaq from './treasurer/TreasurerFaq.vue'
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import OfficeInfo from '@/components/layout/OfficeInfo.vue'
import TextBox from '@/components/layout/TextBox.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import IconText from '@/components/display-utils/IconText.vue'
import IconTitle from '@/components/display-utils/IconTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import NoteText from '@/components/display-utils/NoteText.vue'

export default {
  components: {
    TreasurerFaq,
    PageHeadingInfo,
    OfficeInfo,
    TextBoxTitle,
    TextBox,
    IconText,
    IconTitle,
    LinkBox,
    NoteDocuments,
    NoteText
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

ul {
  -webkit-margin-before: 0.5em;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
  -webkit-padding-start: 1.0em;
}

ul li {
  margin: 0;
}

.tax-desc {
  line-height: 2.0em;
}

</style>
